import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, Link, useNavigate } from "@tanstack/react-router"

import { PageContent } from "@/components/common/page-content"
import { PageHeader } from "@/components/common/page-header"
import { Button } from "@/components/ui/button"
import { ReviewApproveForm } from "@/features/reviews/components/review-change-forms"
import { reviewQueries } from "@/queries/reviews"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/reviews/$reviewId/approve/"
)({
  component: ReviewApprovePage,
})

function ReviewApprovePage() {
  const { reviewId } = Route.useParams()
  const navigate = useNavigate()
  const { data: review } = useSuspenseQuery(reviewQueries.detail(reviewId))

  return (
    <>
      <PageHeader title="Approve" />
      <PageContent>
        <ReviewApproveForm
          review={review}
          cancel={
            <Button
              variant="ghost"
              nativeButton={false}
              render={
                <Link
                  from="/$organisation"
                  to="/$organisation/reviews/$reviewId"
                  params={{ reviewId }}
                />
              }
            >
              Back
            </Button>
          }
          onDone={() =>
            void navigate({
              from: "/$organisation",
              to: "/$organisation/reviews/$reviewId",
              params: { reviewId },
            })
          }
        />
      </PageContent>
    </>
  )
}
